import { render, staticRenderFns } from "./lottery-list-reward.vue?vue&type=template&id=5d0ad6dd&scoped=true&"
import script from "./lottery-list-reward.vue?vue&type=script&lang=js&"
export * from "./lottery-list-reward.vue?vue&type=script&lang=js&"
import style0 from "./lottery-list-reward.vue?vue&type=style&index=0&id=5d0ad6dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ad6dd",
  null
  
)

export default component.exports